import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertSection() {
  return <section className="py-12 md:py-16 bg-teal text-white relative overflow-hidden" data-id="element-80">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-81"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-83">
          <h2 className="text-sm font-bold tracking-widest uppercase text-teal-light mb-8" data-id="element-84">
            💬 LO QUE DICEN LOS EXPERTOS:
          </h2>

          <div className="relative" data-id="element-85">
            <Quote className="absolute -top-6 -left-6 w-16 h-16 text-white/10 rotate-180" data-id="element-86" />
            <p className="text-xl md:text-3xl font-display font-medium leading-relaxed mb-8 relative z-10" data-id="element-87">
              "Este libro es más barato que la terapia es un recurso asombroso
              para cualquiera que busque mejorar su salud mental y emocional.
              Liz Kelly creó una guía divertida, accesible y muy práctica que
              abarca un amplio rango de temas clave y que, sin embargo, está
              basada por completo en el conocimiento científico."
            </p>
            <Quote className="absolute -bottom-6 -right-6 w-16 h-16 text-white/10" data-id="element-88" />
          </div>

          <div className="inline-block border-t border-white/20 pt-6 mt-4" data-id="element-89">
            <p className="font-bold text-lg" data-id="element-90">— Jonah Paquette</p>
            <p className="text-teal-light" data-id="element-91">Psicólogo Clínico y Autor.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}